import * as teams from "@microsoft/teams-js";
import { useEffect, useMemo, useState } from "react";

export const useTeamsContext = () => {
  const [teamsContext, setTeamsContext] = useState<
    teams.app.Context | undefined
  >();

  useEffect(() => {
    const getTeamsContext = async () => {
      const context = await teams.app.getContext();
      setTeamsContext(context);
    };
    getTeamsContext();
  }, []);

  return teamsContext;
};

export const useInMeeting = () => {
  const teamsContext = useTeamsContext();
  return useMemo(() => {
    const inMeeting =
      !!teamsContext &&
      teamsContext.page.frameContext === teams.FrameContexts.sidePanel;
    return inMeeting;
  }, [teamsContext]);
};

export function useIsInTeams() {
  const [isInTeams, setIsInTeams] = useState<boolean | null>(null);

  useEffect(() => {
    // This must be wrapped in a try/catch because initialization can throw if not in Teams
    const detectTeams = async () => {
      try {
        await teams.app.initialize();
        setIsInTeams(true);
      } catch {
        setIsInTeams(false);
      }
    };
    detectTeams();
  }, []);

  return isInTeams;
}
